import React, {
  useState,
  useRef,
  Fragment,
  forwardRef,
  useImperativeHandle,
} from "react";
import debounce from "lodash.debounce";
import InputGroup from "react-bootstrap/InputGroup";
import FormControl from "react-bootstrap/FormControl";
import { FormGroup } from "react-bootstrap";
import { AsyncTypeahead, Menu, MenuItem } from "react-bootstrap-typeahead";

const Search = forwardRef(
  (
    {
      callback,
      placeholder,
      promptText,
      labelKey,
      minLength,
      delay,
      isLoading,
      isTypeAhead,
      options,
      renderMenuItemChildren,
      onChange,
      limitUserToOneGroup,
      style,
    },
    ref
  ) => {
    let inputText = "";
    const inputRef = useRef();
    const minSearchLength = minLength >= 0 ? minLength : 3;

    const handleChange = (event) => {
      let text = "";
      if (event.target) {
        text = event.target.value;
        inputText = text;
      }
      if (text.length === 0 || text.length >= minSearchLength) {
        debounceSearch(callback);
      }
    };

    const handleSearch = (query) => {
      callback(query);
    };

    const handleSubmit = (event) => {
      event.preventDefault();
      event.stopPropagation();
    };

    const debounceSearch = debounce(() => {
      callback(inputText);
    }, delay);

    useImperativeHandle(ref, () => ({
      clearInput() {
        inputRef.current.blur();
      },
      focusInput() {
        inputRef.current.focus();
      },
    }));

    return (
      <form onSubmit={handleSubmit}>
        {isTypeAhead ? (
          <AsyncTypeahead
            placeholder={placeholder}
            promptText={promptText}
            id="1"
            labelKey={labelKey}
            minLength={minSearchLength}
            delay={delay}
            options={options}
            onSearch={handleSearch}
            isLoading={isLoading}
            onChange={(selected) => {
              onChange(selected);
              inputRef.current.clear();
            }}
            renderMenuItemChildren={renderMenuItemChildren}
            ref={inputRef}
            onBlur={() => {
              inputRef.current.clear();
            }}
            emptyLabel={
              limitUserToOneGroup
                ? "No results found or the user is already assigned to another group."
                : "No results found."
            }
          />
        ) : (
          <FormGroup>
            <InputGroup>
              <FormControl
                style={style || {}}
                onChange={(event) => {
                  handleChange(event);
                }}
                placeholder={placeholder}
                aria-label="Group Name"
              />
            </InputGroup>
          </FormGroup>
        )}
      </form>
    );
  }
);

Search.displayName = "Search";

export default Search;
